(() => {
  const STORAGE_KEY = 'recently_viewed';
  const MAX_PRODUCTS = 10;

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.js-recentPdpBlock');
      this.carousel = this.querySelector('fuel-07-carousel');
      if (!this.list || !this.carousel) return;

      const currentProduct = this.readCurrentProduct();
      const history = this.readHistory();
      const productsToRender = history.filter((item) => item.productUrl !== currentProduct?.productUrl).reverse();

      if (currentProduct) this.saveCurrentProduct(history, currentProduct);
      if (productsToRender.length === 0) return;

      productsToRender.forEach((item) => this.list.appendChild(this.buildCard(item)));
      this.hidden = false;
      customElements.whenDefined('fuel-07-carousel').then(() => this.carousel?.updateNavigation());
    }

    readCurrentProduct() {
      try {
        const data = JSON.parse(this.querySelector('[data-recently-viewed-current]')?.textContent || 'null');
        return this.isValidProduct(data) ? data : null;
      } catch (error) {
        return null;
      }
    }

    readHistory() {
      try {
        const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(data) ? data.filter((item) => this.isValidProduct(item)).slice(-MAX_PRODUCTS) : [];
      } catch (error) {
        return [];
      }
    }

    saveCurrentProduct(history, currentProduct) {
      try {
        const updated = history.filter((item) => item.productUrl !== currentProduct.productUrl);
        updated.push(currentProduct);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated.slice(-MAX_PRODUCTS)));
      } catch (error) {
        // Storage can be unavailable in privacy modes; the section still fails closed.
      }
    }

    isValidProduct(item) {
      return Boolean(
        item &&
          typeof item.productTitle === 'string' &&
          typeof item.productImg === 'string' &&
          typeof item.productUrl === 'string' &&
          item.productUrl.startsWith('/products/')
      );
    }

    buildCard(item) {
      const listItem = document.createElement('li');
      const card = document.createElement('article');
      const media = document.createElement('div');
      const imageLink = document.createElement('a');
      const image = document.createElement('img');
      const detailsLink = document.createElement('a');
      const title = document.createElement('h3');
      const priceRow = document.createElement('span');
      const price = document.createElement('span');
      const isOnSale = Number(item.productCompareRaw) > Number(item.productPriceRaw);

      listItem.className = 'fuel-07-carousel__item fuel-07-products__item';
      card.className = 'fuel-07-card';
      media.className = 'fuel-07-card__media';
      imageLink.className = 'fuel-07-card__media-link';
      detailsLink.className = 'fuel-07-card__details';
      priceRow.className = 'fuel-07-card__prices';
      price.className = 'fuel-07-card__price';
      imageLink.href = item.productUrl;
      imageLink.setAttribute('aria-label', `View ${item.productTitle}`);
      image.src = item.productImg;
      image.alt = item.productTitle;
      image.width = 600;
      image.height = 900;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.className = 'fuel-07-card__image';
      detailsLink.href = item.productUrl;
      title.className = 'fuel-07-card__title';
      title.textContent = item.productTitle;
      price.textContent = String(item.productPrice || '');

      imageLink.appendChild(image);

      if (isOnSale) {
        const badge = document.createElement('span');
        const discount = Math.round(((Number(item.productCompareRaw) - Number(item.productPriceRaw)) / Number(item.productCompareRaw)) * 100);
        badge.className = 'fuel-07-card__badge mx-product-card__sale-badge';
        badge.textContent = `${discount}% off`;
        imageLink.appendChild(badge);

        const comparePrice = document.createElement('s');
        comparePrice.className = 'fuel-07-card__compare-price';
        comparePrice.textContent = String(item.productCompare || '');
        priceRow.append(price, comparePrice);
      } else {
        priceRow.appendChild(price);
      }

      media.appendChild(imageLink);
      detailsLink.append(title, priceRow);
      card.append(media, detailsLink);
      listItem.appendChild(card);
      return listItem;
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
